'use client';

import './marketing.css';
import { useReveal } from './primitives';
import { Nav, CTABand, Footer } from './sections/chrome';
import { Hero, StatsStrip } from './sections/hero';
import { LifecycleSection } from './sections/lifecycle';
import { ProductsSection, AudienceSection } from './sections/products';
import { EngineSection } from './sections/engine';
import { VampSection, FaqSection } from './sections/vamp';
import { PricingSection } from './sections/pricing';

/**
 * Public marketing landing — full-page recreation of the design handoff
 * (`site/index.html` → `landing-app.jsx`). Single scrolling page with anchor
 * nav. Self-contained dark theme via the `.fd-site` scope; independent of the
 * app's light/dark setting. `useReveal()` drives the scroll-in animations once
 * the tree mounts (mirrors the prototype's top-level `useReveal()` call).
 */
export function Landing() {
  useReveal();
  return (
    <div className="fd-site">
      <Nav />
      <main>
        <Hero />
        <StatsStrip />
        <LifecycleSection />
        <ProductsSection />
        <EngineSection />
        <AudienceSection />
        <VampSection />
        <PricingSection />
        <FaqSection />
        <CTABand />
      </main>
      <Footer />
    </div>
  );
}
